import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.colors.white,
    border: [1, 'solid', theme.palette.colors.border],
    borderTop: [5, 'solid', theme.palette.colors.teal],
    padding: theme.spacing(2),
    boxShadow: '0px 5px 15px 0px rgba(0,0,0,0.3)',
    borderRadius: [0, 0, 4, 4],
  },
  arrow: {
    fontSize: 22,
    color: theme.palette.colors.teal,
  },
  headerText: {
    color: theme.palette.colors.teal,
  },
  bodyText: {
    color: theme.palette.colors.darkGray,
    marginTop: theme.spacing(1),
    '&:nth-child(2)': {},
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  paper: {
    backgroundColor: theme.palette.colors.white,
    border: [1, 'solid', theme.palette.colors.border],
    borderTop: [5, 'solid', theme.palette.colors.teal],
    borderRadius: [0, 0, 4, 4],
    minWidth: 200,
    padding: theme.spacing(2),
    outline: 'none',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Tooltip/useStyles.js